"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToggleButtons = exports.StyledSettingsTitleText = exports.StyledSettingsHeader = exports.StyledSettingsWrapper = exports.StyledResetButton = exports.StyledButtonsHeader = exports.StyledButtonsWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledButtonsWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;
exports.StyledButtonsHeader = styled_components_1.default.div `
  font-size: ${({ theme }) => theme.spacing(1.5)};
  font-weight: 500;
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette.grey[600]};
`;
exports.StyledResetButton = (0, styled_components_1.default)(ui_components_1.Button) `
  &&& {
    padding: 0.2rem 0;

    color: ${ui_components_1.baseColors.red};
  }
`;
exports.StyledSettingsWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => theme.spacing(2)};
  background-color: ${({ theme }) => theme.palette.common.white};
`;
exports.StyledSettingsHeader = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
exports.StyledSettingsTitleText = styled_components_1.default.div `
  font-size: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.palette.accent.main};
  font-weight: 500;
`;
exports.StyledToggleButtons = (0, styled_components_1.default)(ui_components_1.ToggleButtonGroup) `
  display: flex;

  &.and-or {
    width: 50%;
  }

  & > button {
    flex: 1;
  }
`;
